import api from './api'
import { development }  from '../contexts/auth'
import axios from 'axios'
import { ObjectToHtml } from '../helpers/formaterBanner';

export async function Authtoken(data) {
	if (data) {
		try {
			var config = {
				headers: { 
					'Content-Type': 'multipart/form-data'
				}
			};
			var dataAppend = new FormData();
			dataAppend.append('token',data);
			const response = await api.post('/auth/token', dataAppend, config)
			if (response.status === 200 && response.data && response.data.access_token) {
				return response.data;
			} else {
				return null;
			}
		} catch (e) {
			return null;
		}
	}
}

export async function Products(token) {
	if (token) {
		try {
			var acesso = false;
			api.defaults.headers.Authorization = `Bearer ${token}`;
			const response = await api.post('/products') // https://api.reanimate.com.br/api/products/validate
			if (response.status === 200 && response.data && response.data.products) {
				response.data.products.forEach(products => {
					if (products.title.toLowerCase().includes("replicate")) {
						if (products.status === 1) {
							acesso = true;
						}
					}
				});
				return {
					acesso: acesso,
					roles: {
						ia_resources: response.data.resources.ia_resources,
						compliance: response.data.resources.compliance
					},
					user: {}
					};
			} else {
				return {
					acesso: false,
					roles: {},
					user: {}
					};
			}
		} catch (e) {
			console.log(e)
			return {
				acesso: false,
				roles: {},
				user: {}
				};;
		}
	} return false;
}

export async function LogOut(token = "") {
	try {
		api.defaults.headers.Authorization = `Bearer ${token}`;
		await api.post('/logout');
	} catch (error) {}
}

export async function Info(token = "") {
	try {
		api.defaults.headers.Authorization = `Bearer ${token}`;
		const response = await api.post('/me');
		console.log(response.data.user);
		return response.data.user;
	} catch (error) { return null;}
}

export const apiVideo = axios.create({
	baseURL: "https://dynamic-video.reanimate.com.br/"
	// baseURL: "http://localhost:5000/"
})

const api_url = "https://dynamic-video.reanimate.com.br/";
// const api_url = "http://localhost:5000/";

export async function CriarPasta() {
	try {
		var pasta =  await apiVideo.get('/Reanimate/criar-pasta');
		return pasta.data;
	} catch { return null; }
}

export async function EnviarHtmlVideo(videoModel, pasta) {
	try {
		const config = {
			timeout: 5000,
			headers: {
				'Access-Control-Allow-Origin': '*',
			  },
		  };
		var dataAppend = new FormData();
		dataAppend.append('Html', videoModel.html);
		dataAppend.append('Duration', videoModel.duration);
		dataAppend.append('Fps', videoModel.format.toLowerCase() === 'gif' && videoModel.fps > 50 ? 50 : videoModel.fps);
		dataAppend.append('Width', videoModel.width);
		dataAppend.append('Bitrate', videoModel.bitrate);
		dataAppend.append('Height', videoModel.height);
		dataAppend.append('Format', videoModel.format);
		dataAppend.append('Audio', videoModel.format.toLowerCase() === 'gif' ? null : videoModel.audio);
		dataAppend.append('AudioIA', videoModel.format.toLowerCase() === 'gif' ? null :  videoModel.audioIA);
		dataAppend.append('BitFormat', videoModel.bit ? "yuva444p10le" : "yuv420p");
		dataAppend.append('Path', pasta);
		dataAppend.append('GifQuality', videoModel.gifQuality);
		dataAppend.append('Quality', videoModel.quality);		
		try {
			dataAppend.append('Usuario', videoModel.usuario ?? '');
		} catch {}
		apiVideo.post('/Reanimate/video-reanimate', dataAppend, config);
		return null;
	} catch { return null; }
}

export async function ReceberVideo(arquivo, videoModel) {
	try {
		const response = await fetch(api_url + `reanimate/receber-video-novo?path=${encodeURIComponent(arquivo)}\\out.${videoModel.format.toLowerCase()}`, {
			method: 'GET',
		});
		if (!response.ok) {
			return {
				percentual: 100,
				finalizado: false
			};
		}
		const blob = await response.blob();

		return {
			blob: blob,
			percentual: 100,
			finalizado: true,
			ext: videoModel.format.toLowerCase()
		};
	} catch (error) {
		console.log(error)
		return {
			percentual: 100,
			finalizado: false
		};
	}
}

export async function VerificarStatusVideo(arquivo, videoModel) {
	try {
		const response = await fetch(api_url + `reanimate/verificar-status?path=${encodeURIComponent(arquivo)}\\out.${videoModel.format.toLowerCase()}`, {
			method: 'GET',
		});
		const responseJson = await response.json();
		console.log(responseJson);
		const frames = videoModel.fps * videoModel.duration / 1000;
		return {
			finalizado: responseJson.finalizado,
			percentual: 100 * parseInt(responseJson.percentual) / frames
		}
	} catch {

	}
}

export async function DeletarPasta(path) {
	try {
		console.log("Deletar pasta no servidor...");
		await apiVideo.get('/Reanimate/deletar-pasta?path=' + path);
		return true;
	} catch { return null; }
}


export async function CreatePreview(token, newListaReplicas) {
	let listaReplicas = JSON.parse(JSON.stringify(newListaReplicas));
	if (token) {
		try {

			var config = {
				headers: { 
					'Content-Type': 'multipart/form-data'
				}
			};
			var dataAppend = new FormData();
			dataAppend.append('data_json',JSON.stringify(listaReplicas));

			api.defaults.headers.Authorization = `Bearer ${token}`;
			const response = await api.post('/replicate/add/file', dataAppend, config)

			if(response.status === 200) {
				return {
					status: true,
					id: response.data.id
				}				
			}

		} catch (e) {
			return {
				status: false,
			}
		}
	} 
	
	return {
		status: false,
	};
}

export async function getPreview(item) {
    try {

		var config = {
			headers: { 
				'Content-Type': 'application/json'
			}
		};

		const response = await api.get('/replicate/preview/' + item, null, config);

        if (response.status === 200) {
            return response.data;
        } else {
            console.error('Erro na requisição', response.statusText);
            return null;
        }
    } catch (error) {
        console.log(error)
    }
};